let CustomPage = () => import('../pages/CustomPage.vue');
let Error404 = () => import('../pages/errors/404.vue');

export default [
    {
        path: '/:pageSlug?',
        component: CustomPage,
        name: 'CustomPage',
        meta: { requiresAuth: false },
    },
    {
        path: '*',
        component: Error404,
        name: 'NotFound',
        meta: { requiresAuth: false },
    },
];
